const donorDashboard = {
  year: 'Année fiscale',
  paidTotal: 'Total payé',
  taxDeductible: 'Total déductible d\'impôt',
  paymentsCount: '%count% paiements',
  organisationsIncluded: '%included% sur %total% organisations',
  scheduledTotal: 'Planifié',
  scheduledBreakdown: 'Paiements %payments% · Factures %invoices%',
  scheduledHint: 'Paiements planifiés et montants planifiés sur les factures.',
  unpaidPledges: 'Promesses non payées',
  pledgesCount: '%count% promesses',
  downloadReceipts: 'Reçus d\'impôt (PDF)',
  downloadAll: 'Télécharger tous les reçus',
  downloadAllStarted: 'Préparation des reçus d\'impôt pour toutes les organisations…',
  downloadAllDone: 'Reçus d\'impôt téléchargés pour %count% organisation(s)',
  downloadAllPartial: '%downloaded% organisation(s) téléchargée(s); %skipped% sans reçus ou en échec',
  downloadAllNone: 'Aucun reçu d\'impôt disponible pour l\'année sélectionnée',
  organisationError: 'Impossible de charger cette organisation',
  partialError: 'Certaines données n\'ont pas pu être chargées',
  noActivity: 'Aucune activité en %year%',
  retry: 'Réessayer',
  noOrganisations: 'Aucune organisation connectée',
  noOrganisationsHint: 'Connectez-vous à une organisation pour voir votre sommaire de dons.',
  loadError: 'Impossible de charger le tableau de bord',
  partialTotalsWarning: 'Certaines organisations n\'ont pas pu être chargées; les totaux excluent leurs données.',
};

export default donorDashboard;
